// // Platform.jsx
// import { Helmet } from 'react-helmet-async';
// import { motion, useInView } from 'framer-motion';
// import { useRef, useState } from 'react';
// import {
//   UserCircle, BarChart3, BookOpen, CheckSquare, ClipboardList, FileText,
//   Map, AlertTriangle, Shield, Store, LayoutDashboard, ChevronRight, ArrowRight, Check,
//   Layers, Workflow, FileWarning, ShoppingBag, GraduationCap, FolderTree,
//   MapPin, LineChart, Users, Briefcase
// } from 'lucide-react';
// import Navbar from "../Navbar/Navbar";
// import Footer from "../Footer/Footer";
// import './Platform.css';

// const site = 'https://your-platform.com';

// const iconMap = {
//   UserCircle, BarChart3, BookOpen, CheckSquare, ClipboardList, FileText,
//   Map, AlertTriangle, Shield, Store, LayoutDashboard, Layers, Workflow,
//   FileWarning, ShoppingBag, GraduationCap, FolderTree, MapPin, LineChart, Users, Briefcase
// };

// function FadeUp({ children, delay = 0, className = '' }) {
//   const ref = useRef(null);
//   const inView = useInView(ref, { once: true, margin: '-60px' });
//   return (
//     <motion.div
//       ref={ref}
//       initial={{ opacity: 0, y: 28 }}
//       animate={inView ? { opacity: 1, y: 0 } : {}}
//       transition={{ duration: 0.55, delay, ease: 'easeOut' }}
//       className={className}
//     >
//       {children}
//     </motion.div>
//   );
// }

// export default function PlatformPage() {
//   const [activeModule, setActiveModule] = useState(0);

//   const platform = {
//     hero: {
//   eyebrow: 'CORE PLATFORM',
//   headline: '11 Integrated Modules. One Unified Platform.',
//   subheadline:
//     "Every module is purpose-built for the inspection and competency management lifecycle — from a graduate's first logbook entry to a principal authority's project deployment."
// },
//     modules: [
//        {
//     number: '01',
//     title: 'Digital Surveyor Profile',
//     tagline: 'Your professional identity, verified and portable.',
//     icon: 'UserCircle',
//     description:
//       "A comprehensive professional identity capturing qualifications, certifications, experience, and competency evidence in a single verified record. The Digital Surveyor Profile is the foundation of every professional's presence on Qualion — a living document that grows with each project, certification, and validated competency.",
//     capabilities: [
//       'Verified qualifications and certification records',
//       'Competency evidence portfolio with audit trail',
//       'Professional history and project deployment log',
//       'Portable profile shareable with clients and employers',
//       'Real-time competency level indicator (L0–L5)'
//     ],
//     who_benefits: 'Surveyors, Inspection Companies, Clients'
//   },
//       {
//   number: '02',
//   title: 'Competency Framework',
//   tagline: 'Objective, structured, industry-aligned progression.',
//   icon: 'BarChart3',
//   description:
//     'Structured, industry-aligned competency matrices from L0 to L5, enabling objective assessment and progression tracking. The framework defines exactly what competency looks like at each level — removing subjectivity and ensuring consistent standards across organisations and geographies.',
//   capabilities: [
//     'Role-specific competency matrices by industry',
//     'L0 to L5 progression with defined criteria',
//     'Evidence-based assessment against each competency unit',
//     'Gap analysis and development planning tools',
//     'Alignment with international inspection standards'
//   ],
//   who_benefits:
//     'Graduates, Trainee Surveyors, Mentors, Inspection Companies'
// },
//       {
//   number: '03',
//   title: 'Digital Logbook',
//   tagline: 'Replace paper. Capture everything. Prove it all.',
//   icon: 'BookOpen',
//   description:
//     'Replace paper logbooks with a tamper-proof digital record of field activities, inspections, and learning milestones. Every entry is timestamped, geotagged where applicable, and linked to the relevant competency unit — creating an unbroken chain of evidence from day one.',
//   capabilities: [
//     'Structured daily and weekly field activity logging',
//     'Photo and document attachment per entry',
//     'Automatic linkage to competency framework units',
//     'Mentor review and sign-off workflow',
//     'Tamper-proof timestamped audit trail'
//   ],
//   who_benefits:
//     'Graduates, Trainee Surveyors, Mentors'
// },
//       {
//   number: '04',
//   title: 'Mentor Validation',
//   tagline: 'Structured oversight. Digital approval. Real accountability.',
//   icon: 'CheckSquare',
//   description:
//     'Structured mentor review workflows with digital sign-off, commentary, and evidence approval at every competency stage. Mentors can review logbook entries, assess competency evidence, provide structured feedback, and formally approve progression — all within a traceable digital workflow.',
//   capabilities: [
//     'Assigned mentor-trainee relationship management',
//     'Structured evidence review with commentary',
//     'Digital sign-off at each competency milestone',
//     'Escalation workflows for disputed assessments',
//     'Mentor activity dashboard and workload management'
//   ],
//   who_benefits:
//     'Mentors, Trainee Surveyors, Inspection Companies'
// },
//       {
//   number: '05',
//   title: 'Inspection Workflow',
//   tagline: 'From assignment to report — fully managed.',
//   icon: 'ClipboardList',
//   description:
//     'End-to-end inspection management from assignment to report, with checklists, observations, and NCR tracking built in. The Inspection Workflow module handles the complete lifecycle of an inspection job — mobilisation, execution, observation recording, and final report generation.',
//   capabilities: [
//     'Inspection job creation and surveyor assignment',
//     'Digital checklists with pass/fail/observation recording',
//     'Field observation and NCR raising in real time',
//     'Inspection report generation from field data',
//     'Client-facing inspection status visibility'
//   ],
//   who_benefits:
//     'Surveyors, Inspection Companies, Clients, EPC Contractors'
// },
//       {
//   number: '06',
//   title: 'Document & Certificate Management',
//   tagline: 'Centralised. Searchable. Never expired without warning.',
//   icon: 'FileText',
//   description:
//     'Centralised repository for all professional documents, certificates, and compliance records with expiry alerts. From CSWIP cards to API certifications, every document is stored, categorised, and monitored — with automated alerts before expiry to prevent compliance gaps.',
//   capabilities: [
//     'Centralised document repository with version control',
//     'Certificate expiry tracking with automated alerts',
//     'Document categorisation by type, standard, and scope',
//     'Client and auditor access controls',
//     'Bulk upload and batch management tools'
//   ],
//   who_benefits:
//     'Surveyors, Inspection Companies, Clients, Regulators'
// },
//       {
//   number: '07',
//   title: 'Project Deployment Tracking',
//   tagline: 'Know where your people are. Know what they’ve done.',
//   icon: 'Map',
//   description:
//     'Track surveyor assignments, project timelines, and deployment history with full traceability and reporting. Project Deployment Tracking gives inspection companies and clients complete visibility into who is deployed where, for how long, and with what outcomes.',
//   capabilities: [
//     'Surveyor mobilisation and demobilisation tracking',
//     'Project timeline and milestone management',
//     'Deployment history per surveyor and per project',
//     'Resource availability and scheduling tools',
//     'Client-facing project status reporting'
//   ],
//   who_benefits:
//     'Inspection Companies, EPC Contractors, Clients'
// },
//       {
//   number: '08',
//   title: 'NCR & Observation Management',
//   tagline: 'Raise it. Track it. Close it. Prove it.',
//   icon: 'AlertTriangle',
//   description:
//     'Raise, track, and close non-conformance reports and field observations with structured workflows and audit trails. Every NCR is assigned, tracked through resolution, and closed with documented evidence — providing a complete quality record for clients and regulators.',
//   capabilities: [
//     'NCR creation with severity classification',
//     'Assignment and escalation workflow management',
//     'Resolution tracking with evidence attachment',
//     'Trend analysis and recurring issue identification',
//     'Client-accessible NCR status dashboard'
//   ],
//   who_benefits:
//     'Surveyors, Inspection Companies, EPC Contractors, Clients'
// },
//      {
//   number: '09',
//   title: 'Audit Trail & Evidence Vault',
//   tagline: 'Immutable. Timestamped. Regulator-ready.',
//   icon: 'Shield',
//   description:
//     "Every action, approval, and submission is timestamped and immutable — providing complete assurance for clients and regulators. The Evidence Vault is the backbone of Qualion's assurance proposition — a cryptographically secured record of every significant event in the platform.",
//   capabilities: [
//     'Immutable timestamped record of all platform actions',
//     'Evidence vault with tamper-proof storage',
//     'Regulator-ready audit report generation',
//     'Role-based access to audit records',
//     'Long-term archival with retrieval tools'
//   ],
//   who_benefits:
//     'Inspection Companies, Clients, Regulators, Auditors'
// },
//       {
//   number: '10',
//   title: 'Technical Services Marketplace',
//   tagline: 'Find the right expert. Fast. Verified.',
//   icon: 'ShoppingBag',
//   description:
//     'Connect clients with verified technical service providers for inspection, QA/QC, training, and specialist support. The Marketplace removes the friction of finding qualified inspection professionals — every provider is qualification-verified, with visible competency records and performance history.',
//   capabilities: [
//     'Verified technical service provider listings',
//     'Competency-filtered search and matching',
//     'Service request and proposal management',
//     'Provider performance ratings and history',
//     'Integrated contract and deployment workflow'
//   ],
//   who_benefits:
//     'Clients, EPC Contractors, Inspection Companies, Surveyors'
// },
//      {
//   number: '11',
//   title: 'Dashboard & Reporting',
//   tagline: 'Real-time visibility. Actionable intelligence.',
//   icon: 'LayoutDashboard',
//   description:
//     'Real-time visibility into workforce competency, project status, inspection progress, and compliance metrics. The Dashboard aggregates data from across all modules — giving managers, clients, and executives the intelligence they need to make decisions with confidence.',
//   capabilities: [
//     'Workforce competency status at a glance',
//     'Project and inspection progress tracking',
//     'Compliance and certification expiry monitoring',
//     'Custom report builder with export options',
//     'Role-based dashboard views for every stakeholder'
//   ],
//   who_benefits:
//     'Inspection Companies, Clients, EPC Contractors, Management'
// },
//     ],
//     cta: {
//   headline: 'Ready to See the Platform in Action?',
//   subheadline:
//     'Join the Qualion ecosystem and experience all 11 modules working together for your organisation.',
//   cta_primary: 'Register Interest',
//   cta_secondary: 'Partner With Us'
// },
//   };

//   const jsonLd = {
//     '@context': 'https://schema.org',
//     '@type': 'WebPage',
//     '@id': `${site}/platform#webpage`,
//     name: 'Platform Features — 11 Integrated Modules | Professional Development Platform',
//     url: `${site}/platform`,
//     isPartOf: { '@id': `${site}/#website` },
//     about: { '@id': `${site}/#organization` },
//   };

//   return (
//     <>
//       <Helmet>
//         <title>Platform Features — 11 Integrated Modules | Professional Development Platform</title>
//         <meta name="description" content="Explore our 11 integrated platform modules — from Digital Surveyor Profiles and Competency Frameworks to Inspection Workflows, NCR Management, and the Technical Services Marketplace." />
//         <link rel="canonical" href={`${site}/platform`} />
//         <meta property="og:title" content="Platform Features — 11 Integrated Modules | Professional Development Platform" />
//         <meta property="og:description" content="Every module purpose-built for the inspection and competency management lifecycle." />
//         <meta property="og:type" content="website" />
//         <meta property="og:url" content={`${site}/platform`} />
//         <meta name="twitter:card" content="summary_large_image" />
//         <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
//       </Helmet>

//       <Navbar />

//       <main>
//         {/* ── HERO ── */}
//         <section className="platform-hero">
//           <div className="platform-hero-top-line" />
//           <div className="platform-hero-grid-overlay" />
//           <div className="container">
//             <motion.div
//               initial={{ opacity: 0, y: 32 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.7, ease: 'easeOut' }}
//               className="platform-hero-content"
//             >
//               <div className="platform-hero-eyebrow">
//                 <div className="platform-hero-line" />
//                 <span>{platform.hero.eyebrow}</span>
//               </div>
//               <h1 className="platform-hero-title">{platform.hero.headline}</h1>
//               <p className="platform-hero-subtitle">{platform.hero.subheadline}</p>
//             </motion.div>

//             <motion.div
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               transition={{ duration: 0.8, delay: 0.4 }}
//               className="platform-module-strip"
//             >
//               {platform.modules.map((mod, i) => (
//                 <button
//                   key={i}
//                   onClick={() => setActiveModule(i)}
//                   className={`platform-strip-btn ${activeModule === i ? 'active' : ''}`}
//                 >
//                   {mod.number}
//                 </button>
//               ))}
//             </motion.div>
//           </div>
//         </section>

//         {/* ── MODULE DEEP-DIVE ── */}
//         <section className="platform-modules-section">
//           <div className="container">
//             <div className="platform-modules-grid">
//               {/* Sidebar nav */}
//               <div className="platform-modules-sidebar">
//                 <div className="platform-modules-nav">
//                   {platform.modules.map((mod, i) => {
//                     const Icon = iconMap[mod.icon] || Shield;
//                     return (
//                       <button
//                         key={i}
//                         onClick={() => setActiveModule(i)}
//                         className={`platform-nav-btn ${activeModule === i ? 'active' : ''}`}
//                       >
//                         <span className={`platform-nav-number ${activeModule === i ? 'active' : ''}`}>
//                           {mod.number}
//                         </span>
//                         <Icon size={14} className={`platform-nav-icon ${activeModule === i ? 'active' : ''}`} />
//                         <span className="platform-nav-title">{mod.title}</span>
//                         {activeModule === i && <ChevronRight size={12} className="platform-nav-arrow" />}
//                       </button>
//                     );
//                   })}
//                 </div>
//               </div>

//               {/* Module detail */}
//               <div className="platform-module-detail">
//                 <motion.div
//                   key={activeModule}
//                   initial={{ opacity: 0, x: 16 }}
//                   animate={{ opacity: 1, x: 0 }}
//                   transition={{ duration: 0.3 }}
//                 >
//                   {(() => {
//                     const mod = platform.modules[activeModule];
//                     const Icon = iconMap[mod.icon] || Shield;
//                     return (
//                       <div>
//                         <div className="platform-module-header">
//                           <div className="platform-module-icon-box">
//                             <Icon size={28} className="platform-module-icon" />
//                           </div>
//                           <div>
//                             <div className="platform-module-badge">
//                               <span>MODULE {mod.number}</span>
//                             </div>
//                             <h2 className="platform-module-title">{mod.title}</h2>
//                             <p className="platform-module-tagline">{mod.tagline}</p>
//                           </div>
//                         </div>

//                         <p className="platform-module-description">{mod.description}</p>

//                         <div className="platform-capabilities">
//                           <h3 className="platform-capabilities-title">Key Capabilities</h3>
//                           <div className="platform-capabilities-grid">
//                             {mod.capabilities.map((cap, j) => (
//                               <div key={j} className="platform-capability-item">
//                                 <div className="platform-capability-check">
//                                   <Check size={11} />
//                                 </div>
//                                 <span>{cap}</span>
//                               </div>
//                             ))}
//                           </div>
//                         </div>

//                         <div className="platform-benefits-box">
//                           <div>
//                             <div className="platform-benefits-label">Who Benefits</div>
//                             <div className="platform-benefits-text">{mod.who_benefits}</div>
//                           </div>
//                           <div className="platform-dots">
//                             {platform.modules.map((_, i) => (
//                               <button
//                                 key={i}
//                                 onClick={() => setActiveModule(i)}
//                                 className={`platform-dot ${i === activeModule ? 'active' : ''}`}
//                               />
//                             ))}
//                           </div>
//                         </div>

//                         <div className="platform-nav-buttons">
//                           <button
//                             onClick={() => setActiveModule(Math.max(0, activeModule - 1))}
//                             disabled={activeModule === 0}
//                             className="platform-nav-prev"
//                           >
//                             <ChevronRight size={14} className="rotate-180" />
//                             Previous module
//                           </button>
//                           <button
//                             onClick={() => setActiveModule(Math.min(platform.modules.length - 1, activeModule + 1))}
//                             disabled={activeModule === platform.modules.length - 1}
//                             className="platform-nav-next"
//                           >
//                             Next module
//                             <ChevronRight size={14} />
//                           </button>
//                         </div>
//                       </div>
//                     );
//                   })()}
//                 </motion.div>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* ── ALL MODULES GRID ── */}
//         <section className="platform-grid-section">
//           <div className="container">
//             <FadeUp className="platform-grid-header">
//               <h2>All 11 Modules at a Glance</h2>
//               <p>Click any module to explore it in detail above.</p>
//             </FadeUp>
//             <div className="platform-grid">
//               {platform.modules.map((mod, i) => {
//                 const Icon = iconMap[mod.icon] || Shield;
//                 return (
//                   <FadeUp key={i} delay={i * 0.04}>
//                     <motion.button
//                       whileHover={{ y: -3 }}
//                       transition={{ duration: 0.2 }}
//                       onClick={() => { setActiveModule(i); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
//                       className={`platform-grid-card ${activeModule === i ? 'active' : ''}`}
//                     >
//                       <div className="platform-grid-card-header">
//                         <span className={`platform-grid-card-number ${activeModule === i ? 'active' : ''}`}>
//                           {mod.number}
//                         </span>
//                         <div className={`platform-grid-card-icon ${activeModule === i ? 'active' : ''}`}>
//                           <Icon size={15} />
//                         </div>
//                       </div>
//                       <h3 className={`platform-grid-card-title ${activeModule === i ? 'active' : ''}`}>
//                         {mod.title}
//                       </h3>
//                       <p className={`platform-grid-card-tagline ${activeModule === i ? 'active' : ''}`}>
//                         {mod.tagline}
//                       </p>
//                     </motion.button>
//                   </FadeUp>
//                 );
//               })}
//             </div>
//           </div>
//         </section>

//         {/* ── CTA ── */}
//         <section className="platform-cta">
//           <div className="platform-cta-top-line" />
//           <div className="container">
//             <FadeUp>
//               <div className="platform-cta-content">
//                 <h2>{platform.cta.headline}</h2>
//                 <p>{platform.cta.subheadline}</p>
//                 <div className="platform-cta-buttons">
//                   <a href="/join-ecosystem" className="platform-cta-primary">
//                     {platform.cta.cta_primary} <ArrowRight size={16} />
//                   </a>
//                   <a href="/about" className="platform-cta-secondary">
//                     {platform.cta.cta_secondary} <ChevronRight size={16} />
//                   </a>
//                 </div>
//               </div>
//             </FadeUp>
//           </div>
//         </section>
//       </main>

//       {/* <Footer /> */}
//     </>
//   );
// }



// Platform.jsx
import { Helmet } from 'react-helmet-async';
import { motion, useInView } from 'framer-motion';
import { useRef, useState } from 'react';
import {
  Shield, Lock, FileCheck, Users, Briefcase, Building2,
  BookOpen, ClipboardList, LineChart, FolderTree,
  ChevronRight, ArrowRight, Check, Eye, ShieldCheck,
  GraduationCap, Award, Layers, MapPin
} from 'lucide-react';
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import './Platform.css';

const site = 'https://your-platform.com';

function FadeUp({ children, delay = 0, className = '' }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 28 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.55, delay, ease: 'easeOut' }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export default function PlatformPage() {
  // Reused for the role selector modal on the Join buttons
  const [isRoleModalOpen, setIsRoleModalOpen] = useState(false);

  const content = {
    hero: {
      eyebrow: 'CORE PLATFORM',
      headline: 'Verified Technical Capability. Controlled Project Access.',
      subheadline:
        'A secure ecosystem where technical professionals build verified competency, mentors guide structured development, and organisations deploy assured capability — under role-based, consent-controlled access.',
    },

    // P-03 — Audience paths
    audience: {
      title: 'Find your path',
      subtitle:
        'Choose the experience that matches your role. Access is verified and role-based.',
      cards: [
        {
          icon: 'Briefcase',
          role: 'Technical Professional',
          slug: 'candidate',
          outcome:
            'Build a verified competency record and get discovered for the right projects.',
          cta: 'Join as Technical Professional',
        },
        {
          icon: 'Users',
          role: 'Mentor',
          slug: 'mentor',
          outcome:
            'Guide structured development and formally validate competency progression.',
          cta: 'Join as Mentor',
        },
        {
          icon: 'Building2',
          role: 'Organisation',
          slug: 'organization',
          outcome:
            'Deploy verified capability with controlled project access and auditable assurance.',
          cta: 'Request Organisation Access',
        },
      ],
    },

    // P-04 — Problem framing
    problem: {
      title: 'The problem we address',
      items: [
        {
          title: 'Fragmented experience evidence',
          body: 'Professional history and competency proof are scattered across documents, spreadsheets and inboxes.',
        },
        {
          title: 'Inconsistent competency validation',
          body: 'How competency is judged varies by reviewer, region and organisation — creating risk.',
        },
        {
          title: 'Slow access to suitable capability',
          body: 'Finding verified, appropriately qualified professionals takes too long and too many calls.',
        },
        {
          title: 'Disconnected project records',
          body: 'Field activity, approvals and assurance evidence live in systems that do not talk to each other.',
        },
      ],
    },

    // P-05 — Outcomes
    outcomes: {
      title: 'What the platform delivers',
      subtitle:
        'Four outcomes that align professional development with assured project delivery.',
      cards: [
        {
          icon: 'ShieldCheck',
          title: 'Verified Competency',
          body: 'Evidence-backed competency records validated against a structured framework.',
        },
        {
          icon: 'GraduationCap',
          title: 'Structured Development',
          body: 'Guided progression with mentor oversight and defined milestones.',
        },
        {
          icon: 'Layers',
          title: 'Controlled Deployment',
          body: 'Role-based project access aligned to verified capability and entitlement.',
        },
        {
          icon: 'FileCheck',
          title: 'Auditable Assurance',
          body: 'Immutable, regulator-ready records of approvals and project evidence.',
        },
      ],
    },

    // P-06 — 4 public solution previews (no module names, no screenshots, no workflows)
    solutions: {
      title: 'Solution previews',
      subtitle:
        'High-level capabilities. Detailed modules and workflows are available inside approved demonstrations.',
      cards: [
        {
          icon: 'ShieldCheck',
          title: 'Competency Assurance',
          body: 'Structured frameworks and evidence-based validation that make competency comparable across roles and regions.',
        },
        {
          icon: 'GraduationCap',
          title: 'Mentorship & Development',
          body: 'Guided progression with mentor oversight, structured feedback and defined progression milestones.',
        },
        {
          icon: 'Eye',
          title: 'Verified Professional Access',
          body: 'Role-verified identity and entitlement control across professionals, mentors and organisations.',
        },
        {
          icon: 'FolderTree',
          title: 'Project Collaboration & Records',
          body: 'Connected project records and audit-ready evidence shared securely between authorised parties.',
        },
      ],
    },

    // P-08 — Industries preview (short relevance only)
    industries: {
      title: 'Built for assured industries',
      subtitle:
        'Wherever verified technical capability and auditable project records matter.',
      cards: [
        { icon: 'MapPin', name: 'Oil & Gas',          line: 'Verified inspection capability for high-risk assets.' },
        { icon: 'MapPin', name: 'Marine & Offshore',  line: 'Assured competency across offshore operations.' },
        { icon: 'MapPin', name: 'Infrastructure',     line: 'Structured assurance for critical builds.' },
        { icon: 'MapPin', name: 'Manufacturing',      line: 'Consistent quality and competency evidence.' },
        { icon: 'MapPin', name: 'Energy & Renewables', line: 'Verified capability for a changing energy mix.' },
        { icon: 'MapPin', name: 'EPC & Contracting',  line: 'Controlled deployment of qualified teams.' },
      ],
      cta: 'Explore industries',
    },

    // P-09 — How access works (reflects Level 1–3, no automatic approval implied)
    access: {
      title: 'How access works',
      subtitle:
        'Access is verified and controlled. Approval is not automatic and depends on role and entitlement.',
      steps: [
        {
          number: '01',
          icon: 'Eye',
          title: 'Explore publicly',
          body: 'Understand the platform, its outcomes and the role paths available.',
        },
        {
          number: '02',
          icon: 'ShieldCheck',
          title: 'Register and verify',
          body: 'Submit your details and role. Verification is completed before access is granted.',
        },
        {
          number: '03',
          icon: 'Lock',
          title: 'Receive approved dashboard access',
          body: 'Approved users gain role-based access to the relevant dashboard and workspace.',
        },
      ],
    },

    // P-10 — Principle-based trust indicators (no counts, no unverified certifications)
    trust: {
      title: 'Designed on principles you can rely on',
      items: [
        { icon: 'BookOpen',     label: 'Evidence-led' },
        { icon: 'Lock',         label: 'Role-based' },
        { icon: 'ShieldCheck',  label: 'Consent-controlled' },
        { icon: 'FileCheck',    label: 'Audit-ready' },
      ],
    },

    // P-11 — Final CTA
    cta: {
      headline: 'Join the Qualion ecosystem',
      subheadline:
        'Choose your role and start the verification process. Access is granted after approval.',
      primary: 'Join Ecosystem',
      secondary: 'Sign In',
    },
  };

  const audienceIconMap = { Briefcase, Users, Building2 };
  const outcomeIconMap = {
    ShieldCheck, GraduationCap, Layers, FileCheck,
    Eye, FolderTree, MapPin, Lock, BookOpen,
  };

  const handleJoin = () => setIsRoleModalOpen(true);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${site}/platform#webpage`,
    name: 'Platform — Verified Technical Capability & Controlled Project Access',
    url: `${site}/platform`,
    isPartOf: { '@id': `${site}/#website` },
    about: { '@id': `${site}/#organization` },
  };

  return (
    <>
      <Helmet>
        <title>Platform — Verified Technical Capability & Controlled Project Access</title>
        <meta
          name="description"
          content="A secure ecosystem for verified technical capability, structured mentorship and controlled project access. Explore outcomes and choose your role path."
        />
        <link rel="canonical" href={`${site}/platform`} />
        <meta property="og:title" content="Platform — Verified Technical Capability & Controlled Project Access" />
        <meta property="og:description" content="Verified competency, structured development and auditable assurance." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${site}/platform`} />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>

      <Navbar />

      <main>
        {/* ── HERO (P-01, P-02) ── */}
        <section className="platform-hero">
          <div className="platform-hero-top-line" />
          <div className="platform-hero-grid-overlay" />
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 32 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: 'easeOut' }}
              className="platform-hero-content"
            >
              <div className="platform-hero-eyebrow">
                <div className="platform-hero-line" />
                <span>{content.hero.eyebrow}</span>
              </div>
              <h1 className="platform-hero-title">{content.hero.headline}</h1>
              <p className="platform-hero-subtitle">{content.hero.subheadline}</p>

              {/* Only two actions: Join Ecosystem (primary) + Sign In (secondary) */}
              <div className="platform-hero-actions">
                <button
                  type="button"
                  className="platform-cta-primary"
                  onClick={handleJoin}
                >
                  Join Ecosystem <ArrowRight size={16} />
                </button>
                <a href="/login" className="platform-cta-secondary">
                  Sign In
                </a>
              </div>
            </motion.div>
          </div>
        </section>

        {/* ── AUDIENCE (P-03) ── */}
        <section className="platform-section platform-audience-section">
          <div className="container">
            <FadeUp className="platform-section-header">
              <h2>{content.audience.title}</h2>
              <p>{content.audience.subtitle}</p>
            </FadeUp>

            <div className="platform-audience-grid">
              {content.audience.cards.map((card, i) => {
                const Icon = audienceIconMap[card.icon] || Briefcase;
                return (
                  <FadeUp key={card.role} delay={i * 0.08}>
                    <div className="platform-audience-card">
                      <div className="platform-audience-icon">
                        <Icon size={22} />
                      </div>
                      <h3 className="platform-audience-role">{card.role}</h3>
                      <p className="platform-audience-outcome">{card.outcome}</p>
                      <button
                        type="button"
                        className="platform-audience-cta"
                        onClick={handleJoin}
                      >
                        {card.cta} <ChevronRight size={14} />
                      </button>
                    </div>
                  </FadeUp>
                );
              })}
            </div>
          </div>
        </section>

        {/* ── PROBLEM (P-04) ── */}
        <section className="platform-section platform-problem-section">
          <div className="container">
            <FadeUp className="platform-section-header">
              <h2>{content.problem.title}</h2>
            </FadeUp>
            <div className="platform-problem-grid">
              {content.problem.items.map((item, i) => (
                <FadeUp key={item.title} delay={i * 0.06}>
                  <div className="platform-problem-card">
                    <h3>{item.title}</h3>
                    <p>{item.body}</p>
                  </div>
                </FadeUp>
              ))}
            </div>
          </div>
        </section>

        {/* ── OUTCOMES (P-05) ── */}
        <section className="platform-section platform-outcomes-section">
          <div className="container">
            <FadeUp className="platform-section-header">
              <h2>{content.outcomes.title}</h2>
              <p>{content.outcomes.subtitle}</p>
            </FadeUp>
            <div className="platform-outcomes-grid">
              {content.outcomes.cards.map((card, i) => {
                const Icon = outcomeIconMap[card.icon] || Shield;
                return (
                  <FadeUp key={card.title} delay={i * 0.06}>
                    <div className="platform-outcome-card">
                      <div className="platform-outcome-icon">
                        <Icon size={20} />
                      </div>
                      <h3>{card.title}</h3>
                      <p>{card.body}</p>
                    </div>
                  </FadeUp>
                );
              })}
            </div>
          </div>
        </section>

        {/* ── SOLUTION PREVIEWS (P-06) ── */}
        <section className="platform-section platform-solutions-section">
          <div className="container">
            <FadeUp className="platform-section-header">
              <h2>{content.solutions.title}</h2>
              <p>{content.solutions.subtitle}</p>
            </FadeUp>
            <div className="platform-solutions-grid">
              {content.solutions.cards.map((card, i) => {
                const Icon = outcomeIconMap[card.icon] || Shield;
                return (
                  <FadeUp key={card.title} delay={i * 0.06}>
                    <motion.div
                      whileHover={{ y: -3 }}
                      transition={{ duration: 0.2 }}
                      className="platform-solution-card"
                    >
                      <div className="platform-solution-icon">
                        <Icon size={20} />
                      </div>
                      <h3>{card.title}</h3>
                      <p>{card.body}</p>
                    </motion.div>
                  </FadeUp>
                );
              })}
            </div>
          </div>
        </section>

        {/* ── INDUSTRIES PREVIEW (P-08) ── */}
        <section className="platform-section platform-industries-section">
          <div className="container">
            <FadeUp className="platform-section-header">
              <h2>{content.industries.title}</h2>
              <p>{content.industries.subtitle}</p>
            </FadeUp>

            <div className="platform-industries-grid">
              {content.industries.cards.map((card, i) => (
                <FadeUp key={card.name} delay={i * 0.04}>
                  <div className="platform-industry-card">
                    <div className="platform-industry-name">{card.name}</div>
                    <p className="platform-industry-line">{card.line}</p>
                  </div>
                </FadeUp>
              ))}
            </div>

            <FadeUp delay={0.1} className="platform-industries-cta-wrap">
              <a href="/industries" className="platform-industries-cta">
                {content.industries.cta} <ArrowRight size={16} />
              </a>
            </FadeUp>
          </div>
        </section>

        {/* ── HOW ACCESS WORKS (P-09) ── */}
        <section className="platform-section platform-access-section">
          <div className="container">
            <FadeUp className="platform-section-header">
              <h2>{content.access.title}</h2>
              <p>{content.access.subtitle}</p>
            </FadeUp>
            <div className="platform-access-grid">
              {content.access.steps.map((step, i) => {
                const Icon = outcomeIconMap[step.icon] || Lock;
                return (
                  <FadeUp key={step.number} delay={i * 0.08}>
                    <div className="platform-access-step">
                      <div className="platform-access-step-top">
                        <span className="platform-access-number">{step.number}</span>
                        <div className="platform-access-icon">
                          <Icon size={18} />
                        </div>
                      </div>
                      <h3>{step.title}</h3>
                      <p>{step.body}</p>
                    </div>
                  </FadeUp>
                );
              })}
            </div>
          </div>
        </section>

        {/* ── TRUST PRINCIPLES (P-10) ── */}
        <section className="platform-section platform-trust-section">
          <div className="container">
            <FadeUp className="platform-section-header">
              <h2>{content.trust.title}</h2>
            </FadeUp>
            <div className="platform-trust-grid">
              {content.trust.items.map((item, i) => {
                const Icon = outcomeIconMap[item.icon] || Shield;
                return (
                  <FadeUp key={item.label} delay={i * 0.05}>
                    <div className="platform-trust-item">
                      <Icon size={18} className="platform-trust-icon" />
                      <span>{item.label}</span>
                    </div>
                  </FadeUp>
                );
              })}
            </div>
          </div>
        </section>

        {/* ── FINAL CTA (P-11) ── */}
        <section className="platform-cta">
          <div className="platform-cta-top-line" />
          <div className="container">
            <FadeUp>
              <div className="platform-cta-content">
                <h2>{content.cta.headline}</h2>
                <p>{content.cta.subheadline}</p>
                <div className="platform-cta-buttons">
                  <button
                    type="button"
                    className="platform-cta-primary"
                    onClick={handleJoin}
                  >
                    {content.cta.primary} <ArrowRight size={16} />
                  </button>
                  <a href="/login" className="platform-cta-secondary">
                    {content.cta.secondary}
                  </a>
                </div>
              </div>
            </FadeUp>
          </div>
        </section>
      </main>

      {/* Role selector modal — same behaviour as Navbar's Join Ecosystem */}
      {isRoleModalOpen && (
        <RoleModal
          onClose={() => setIsRoleModalOpen(false)}
        />
      )}

      {/* <Footer /> */}
    </>
  );
}

/* ── Role selector modal (P-11) ──
   Mirrors the Navbar modal so both entry points route to the same
   /join-ecosystem?role=<slug> flow. Internal slug for Technical
   Professional remains "candidate".
*/
function RoleModal({ onClose }) {
  const options = [
    { slug: 'candidate',    label: 'Technical Professional', description: 'Build a verified competency record.', icon: Briefcase },
    { slug: 'mentor',       label: 'Mentor',                 description: 'Guide structured development.',       icon: Users },
    { slug: 'organization', label: 'Organisation',           description: 'Deploy assured capability.',          icon: Building2 },
  ];

  const select = (slug) => {
    window.location.href = `/join-ecosystem?role=${slug}`;
  };

  return (
    <div className="role-modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="role-modal" role="dialog" aria-modal="true" aria-labelledby="role-modal-title">
        <div className="role-modal-header">
          <div>
            <h2 id="role-modal-title" className="role-modal-title">Join the Ecosystem</h2>
            <p className="role-modal-subtitle">Choose how you'd like to get started.</p>
          </div>
          <button type="button" className="role-modal-close" onClick={onClose} aria-label="Close">×</button>
        </div>
        <div className="role-modal-options">
          {options.map((opt) => {
            const Icon = opt.icon;
            return (
              <button
                key={opt.slug}
                type="button"
                className="role-option"
                onClick={() => select(opt.slug)}
              >
                <span className="role-option-icon"><Icon size={20} /></span>
                <span className="role-option-body">
                  <span className="role-option-label">{opt.label}</span>
                  <span className="role-option-desc">{opt.description}</span>
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}